import Home from './Home'
import Lock from './Lock'
import SingleUser from './SingleUser'
import Search from './Search'
import ChevronDown from './ChevronDown'
import Cancel from './Cancel'
import ChecklistCircle from './ChecklistCircle'
import User from './User'
import Invoice from './Invoice'
import List from './List'
import ClipboardClose from './ClipboardClose'
import CaretDown from './CaretDown'
import MoreCircle from './MoreCircle'
import ArrowLeft from './ArrowLeft'

export const IconHome = Home
export const IconLock = Lock
export const IconSingleUser = SingleUser
export const IconSearch = Search
export const IconChevronDown = ChevronDown
export const IconCancel = Cancel
export const IconChecklistCircle = ChecklistCircle
export const IconUser = User
export const IconInvoice = Invoice
export const IconList = List
export const IconClipboardClose = ClipboardClose
export const IconCaretDown = CaretDown
export const IconMoreCircle = MoreCircle
export const IconArrowLeft = ArrowLeft
